export default function Footer() {
  return (
    <div className="flex justify-center items-center h-16 mx-auto px-4 bg-[#1C1C1C] text-white mt-auto">
      <h1 className="font-black font-libre">
        <b className="text-[#EE6164]">2025</b> - CHRISTIAN DUARTE
      </h1>
    </div>
  );
}
